import "./Hero.css";

export default function Hero() {
  return (
    <section className="hero">
      <div className="hero-content">
        <h1 className="hero-title">
          Unlock deeper biblical understanding with guided insights.
        </h1>
        <h2 className="hero-subtitle">
          Daily Hebrew and Greek translations for Advent
        </h2>
      </div>
    </section>
  );
}
